module.exports = __webpack_public_path__ + "img/TruckTractor.754b490b.png";